(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["people-theatre-smart-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pot-smart-hero')) {
    customElements.define('pot-smart-hero', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.heightFrame);
        clearInterval(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      init() {
        this.events?.abort();
        this.observer?.disconnect();
        clearInterval(this.timer);
        const track = this.querySelector('[data-psh-track]');
        const slides = [...this.querySelectorAll('[data-psh-slide]')];
        if (!track || !slides.length) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const dots = [...this.querySelectorAll('[data-psh-dot]')];
        const mobile = matchMedia('(max-width: 749px)');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const autoplay = this.dataset.autoplay === 'true';
        const interval = Math.max(3000, Number(this.dataset.interval) || 6000);
        let index = 0;
        let hovered = false;

        const syncHeight = () => {
          cancelAnimationFrame(this.heightFrame);
          this.heightFrame = requestAnimationFrame(() => {
            if (this.isConnected) track.style.height = `${slides[index].offsetHeight}px`;
          });
        };
        const syncVideos = () => {
          slides.forEach((slide, slideIndex) => {
            slide.querySelectorAll('video').forEach((video) => {
              if (slideIndex !== index || document.hidden || !video.getClientRects().length) {
                video.pause();
              } else if (video.autoplay && !reducedMotion.matches) {
                video.play()?.catch(() => {});
              }
            });
          });
        };
        const render = () => {
          track.style.transform = `translateX(-${index * 100}%)`;
          slides.forEach((slide, slideIndex) => {
            slide.inert = slideIndex !== index;
            slide.setAttribute('aria-hidden', String(slideIndex !== index));
            slide.setAttribute('aria-label', `${slideIndex + 1} / ${slides.length}`);
          });
          dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
          syncHeight();
          syncVideos();
        };
        const restart = () => {
          clearInterval(this.timer);
          const disabledOnMobile = mobile.matches && this.dataset.pauseOnMobile === 'true';
          if (!this.isConnected || !autoplay || slides.length < 2 || hovered || document.hidden ||
              this.contains(document.activeElement) || reducedMotion.matches || disabledOnMobile) return;
          this.timer = setInterval(() => {
            index = (index + 1) % slides.length;
            render();
          }, interval);
        };
        const go = (nextIndex) => {
          index = (nextIndex + slides.length) % slides.length;
          render();
          restart();
        };
        this.querySelector('[data-psh-prev]')?.addEventListener('click', () => go(index - 1), options);
        this.querySelector('[data-psh-next]')?.addEventListener('click', () => go(index + 1), options);
        dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => go(dotIndex), options));
        this.addEventListener('mouseenter', () => { hovered = true; restart(); }, options);
        this.addEventListener('mouseleave', () => { hovered = false; restart(); }, options);
        this.addEventListener('focusin', restart, options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) queueMicrotask(restart);
        }, options);
        this.querySelectorAll('img').forEach((image) => image.addEventListener('load', syncHeight, options));
        this.querySelectorAll('video').forEach((video) => video.addEventListener('loadedmetadata', syncHeight, options));
        window.addEventListener('resize', syncHeight, options);
        mobile.addEventListener('change', () => { render(); restart(); }, options);
        reducedMotion.addEventListener('change', () => { syncVideos(); restart(); }, options);
        document.addEventListener('visibilitychange', () => { syncVideos(); restart(); }, options);
        if (typeof ResizeObserver !== 'undefined') {
          this.observer = new ResizeObserver(syncHeight);
          slides.forEach((slide) => this.observer.observe(slide));
        }
        render();
        restart();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
